import './selectedContractor.scss';

import { FormattedMessage } from 'react-intl';

import { Contractor } from '~types/appsync.types';

interface SelectedContractorProps {
  contractor: Contractor;
}

const SelectedContractor = ({ contractor }: SelectedContractorProps) => {
  return (
    <div className='SelectedContractor'>
      <div className='SelectedContractor_title'>
        <div className='SelectedContractor_domain'>
          <FormattedMessage id='resort' defaultMessage='Resort' />
        </div>
        <div className='SelectedContractor_value'>{contractor.name}</div>
      </div>
    </div>
  );
};

export default SelectedContractor;
